import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { HourlyResultsMono as Component } from './HourlyResultsMono.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

type IInjectedProps = IStateProps & IDispatchProps;

export type IProps = IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  return {
    routeMonoSimulationGroup: selectRouteResource(rrc.mono_simulation_group)(rootState),
  };
};

const mapDispatchToProps = {};

export const HourlyResultsMono = connect(mapStateToProps, mapDispatchToProps)(Component);
